import { createSelector } from 'reselect'

/**
 * Select the Firestore state slice
 * @param {object} state - Redux state
 * @returns {object} Firestore state
 */
export const selectFirestore = (state) => state.firestore

/**
 * Select all Firestore data
 * @param {object} state - Redux state
 * @returns {object} Firestore data
 */
export const selectFirestoreData = createSelector(
  selectFirestore,
  (firestore) => firestore.data
)

/**
 * Create a memoized selector for a specific Firestore document
 * @param {string} collection - Firestore collection name
 * @param {string} documentId - Document ID within the collection
 * @returns {Function} Selector that returns the document data
 */
export const makeSelectFirestoreDocument = (collection, documentId) =>
  createSelector(
    selectFirestoreData,
    (data) => data[collection] && data[collection][documentId]
  )

/**
 * Create a memoized selector for a Firestore collection
 * @param {string} collection - Firestore collection name
 * @returns {Function} Selector that returns the collection data
 */
export const makeSelectFirestoreCollection = (collection) =>
  createSelector(
    selectFirestoreData,
    (data) => data[collection]
  )
